import vueUIInitiator from '../../../modules/vue-ui-initiator';
import ItVacanciesPage from '../../../vue-components/ItVacanciesPage';
import ItVacancyContentSlider from '../../../vue-components/ItVacancyContentSlider'; // /career/it-vacancies/
import FormVacancies from '../../../vue-components/FormVacancies';

vueUIInitiator('js--it-vacancies-page', ItVacanciesPage, 'it-vacancies-page');
vueUIInitiator('js--itv-content-slider', ItVacancyContentSlider, 'itv-content-slider');
vueUIInitiator('js--form-vacancies', FormVacancies, 'form-vacancies');
